import { useEffect, useState } from 'react';
import { LuX } from 'react-icons/lu';

const CHIAVE_CHIP = 'dimora.chip-demo-chiuso';

/**
 * Chip "Demo" persistente e discreto: ricorda che l'ambiente è dimostrativo.
 * Chiudibile per la sessione corrente (sessionStorage).
 */
export default function ChipDemo() {
  const [visibile, setVisibile] = useState(false);

  useEffect(() => {
    try {
      setVisibile(sessionStorage.getItem(CHIAVE_CHIP) !== '1');
    } catch (e) {
      setVisibile(true);
    }
  }, []);

  if (!visibile) {
    return null;
  }

  return (
    <div
      data-cy="chipDemo"
      title="Ambiente dimostrativo"
      className="fixed bottom-4 right-4 z-40 flex items-center gap-1 rounded-full border py-1 pl-3 pr-1.5 text-xs font-medium shadow-sm"
      style={{
        backgroundColor: '#E0F2FE',
        color: '#075985',
        borderColor: '#BAE6FD'
      }}
    >
      Demo
      <button
        type="button"
        aria-label="Nascondi per questa sessione"
        className="grid size-4 place-items-center rounded-full transition-colors hover:bg-[#BAE6FD]"
        onClick={() => {
          setVisibile(false);
          try {
            sessionStorage.setItem(CHIAVE_CHIP, '1');
          } catch (e) {
            /* la chiusura vale comunque fino al prossimo caricamento */
          }
        }}
      >
        <LuX className="size-3" />
      </button>
    </div>
  );
}
